import { motion } from 'framer-motion';
import { useEffect } from 'react';

export default function LoadingScreen({ onComplete }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete();
    }, 2500); // 2.5 seconds

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="min-h-screen bg-warm-beige flex items-center justify-center p-6">
      <div className="max-w-md text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="text-3xl font-bold text-charcoal mb-8">
            Tailoring your recommendation...
          </h2>

          {/* Animated progress bar */}
          <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden mb-8">
            <motion.div
              className="h-full bg-renuvia-gold"
              initial={{ width: 0 }}
              animate={{ width: '100%' }}
              transition={{ duration: 2, ease: 'easeInOut' }}
            />
          </div>

          {/* Benefit pills */}
          <div className="flex flex-wrap justify-center gap-3">
            {['Clinically-backed', 'Doctor-approved', 'Personalized'].map((benefit, i) => (
              <motion.div
                key={benefit}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: i * 0.3 }}
                className="px-4 py-2 bg-white rounded-full text-sm text-slate"
              >
                {benefit}
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
